// extracted by mini-css-extract-plugin
export default {"selector":"Routes_selector__K+cB2","newRouteBtn":"Routes_newRouteBtn__4lGDm"};